module.exports = __webpack_public_path__ + "agency/43f4ca68e4b6443d64a7678bbad79e8d.png";